module.exports = __webpack_public_path__ + "img/12.9494f1e6.jpg";